import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { Button } from 'antd'
import WhiteSpace from 'components/WhiteSpace'

function Loading(props) {
  const handleRetry = () => {
    props.retry()
  }
  if (props.error) {
    return (
      <div className={classes.componentsLoading}>
        <h3>Loadable Error</h3>
        <h5>please try later!</h5>
        <div className='white-space' />
        <div className='white-space' />
        <Button size='small' onClick={handleRetry}>
          <b>Retry</b>
        </Button>
      </div>
    )
  } else if (props.timedOut) {
    return (
      <div className={classes.componentsLoading}>
        <h3>Taking a long time</h3>
        <h5>please try later!</h5>
        <div className='white-space' />
        <div className='white-space' />
        <Button size='small' onClick={handleRetry}>
          <b>Retry</b>
        </Button>
      </div>
    )
  } else if (props.pastDelay) {
    return <div className='global-logo-loading' />
  } else if (props.inlineNormalLoading) {
    return (
      <div className='inline-normal-loading'>
        <span />
        {props.children && (
          <React.Fragment>
            <WhiteSpace />
            <div className='font-12 text_secondary'>{props.children}</div>
          </React.Fragment>
        )}
      </div>
    )
  } else if (props.processing) {
    return <div className='normal-processing' />
  } else {
    return null
  }
}

export default Loading
